import React from 'react';
import {
  createTheme,
  darkTheme,
  genPageTheme,
  shapes
} from '@backstage/theme';

import { AppTheme } from '@backstage/core-plugin-api';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import DarkIcon from '@material-ui/icons/Brightness2';

const cobliDarkPalette = {
  ...darkTheme.palette,
  primary: {
    main: '#1E90FF',
  },
  secondary: {
    main: '#23C660',
  },
  error: {
    main: '#d1160e'
  },
  warning: {
    main: '#000000',
  },
  info: {
    main: '#123456',
  },
  success: {
    main: '#123456',
  },
  background: {
    default: '#333',
    paper: '#424242',
  },
  banner: {
    info: '#23c660',
    error: '#23c660',
    text: '#23c660',
    link: '#23c660',
  },
  errorBackground: '#d1160e',
  warningBackground: '#f08c00',
  infoBackground: '#123456',
  navigation: {
    background: '#18182E',
    indicator: '#f4f7f9',
    color: '#9da9b6',
    selectedColor: '#f4f7f9',
  },
}

const appDarkTheme = createTheme({
  palette: cobliDarkPalette,
  fontFamily: 'Roboto,Arial,sans-serif',
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#1e2535', '#18182E'], shape: shapes.wave }),
    documentation: genPageTheme({ colors: ['#1e2535', '#18182E'], shape: shapes.wave2 }),
    tool: genPageTheme({ colors: ['#1e2535', '#18182E'], shape: shapes.round }),
    service: genPageTheme({ colors: ['#1e2535', '#18182E'], shape: shapes.wave }),
    website: genPageTheme({ colors: ['#1e2535', '#18182E'], shape: shapes.wave }),
    library: genPageTheme({ colors: ['#1e2535', '#18182E'], shape: shapes.wave }),
    other: genPageTheme({ colors: ['##1e2535', '#18182E'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#1e2535', '#18182E'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#1e2535', '#18182E'], shape: shapes.wave }),
  },
});


export const cobliDarkTheme: Partial<AppTheme> & Omit<AppTheme, "theme"> = {
  id: 'cobli-dark-theme',
  title: 'Cobli Custom Dark Theme',
  variant: 'dark',
  icon: <DarkIcon />,
  Provider: ({ children }: { children: any }) => (
    <ThemeProvider theme={appDarkTheme}>
      <CssBaseline>{children}</CssBaseline>
    </ThemeProvider>
  ),
};
